import { useMemo } from "react";
import { useShallow } from "zustand/shallow";

import { useGenomeViewerStore } from "../../../store/store.ts";
import { getVisibleAreaBox } from "../utils/visible-area-box.ts";

export function useVisibleAreaBox(scale: number, panelHeight: number, panelWidth: number) {
  const { scrollX, canvasWidth, originOffset } = useGenomeViewerStore(
    useShallow((state) => ({
      scrollX: state.scrollX,
      canvasWidth: state.canvas?.width ?? 0,
      originOffset: -state.getOriginOffset(),
    })),
  );

  return useMemo(
    () => getVisibleAreaBox(scale, panelHeight, panelWidth, canvasWidth, scrollX + originOffset),
    [scale, panelHeight, panelWidth, canvasWidth, scrollX, originOffset],
  );
}
